import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; // eslint-disable-line

import ResponsiveVideoEmbed from "../../helpers/ResponsiveVideoEmbed.js";

import belediyeBinasi from "images/yenimahalle/belediyeBinasi.jpg";

const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover`}
  background-image: url(${belediyeBinasi});
`;

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-primary-800 opacity-50`;

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const TwoColumn = tw.div`pt-24 pb-32 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex flex-col items-center lg:block`;
const RightColumn = tw.div`w-full sm:w-5/6 lg:w-1/2 mt-16 lg:mt-0 lg:pl-8`;
const ButtonsRow = tw.div`flex space-x-4`;

const Heading = styled.h1`
  ${tw`pl-0 md:pl-10 text-3xl text-center md:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative text-primary-500 px-4 -mx-4 py-2`}
  &::before {
    content: "";
    ${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
  }
`;

const Notification = tw.span`inline-block my-4 pl-3 py-1 text-gray-100 border-l-4 border-primary-500 font-medium text-sm`;

const PrimaryAction = tw.button`
  px-8 py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 
  bg-gray-100 text-primary-500 font-bold 
  rounded shadow 
  transition duration-300 
  hocus:bg-primary-500 hocus:text-gray-100 
  focus:shadow-outline
`;

const SecondaryAction = tw.button`
  px-8 py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 
  bg-gray-100 text-secondary-500 font-bold 
  rounded shadow 
  transition duration-300 
  hocus:bg-secondary-500 hocus:text-gray-100 
  focus:shadow-outline
`;

const StyledResponsiveVideoEmbed = styled(ResponsiveVideoEmbed)`
  padding-bottom: 56.25% !important;
  padding-top: 0px !important;
  ${tw`rounded`}
  iframe {
    ${tw`rounded bg-black shadow-xl`}
  }
`;

const Photo = styled.img`
  ${tw`rounded bg-black shadow-xl w-full`}
  object-fit: cover;
`;

export default function ContentHeader({
  photoUrl = null,
  videoUrl = null,
  primaryButtonUrl = null,
  primaryButtonText = "Detaylar",
  secondaryButtonUrl = null,
  secondaryButtonText = "İletişim",
  topNotification = null,
  bottomNotification = null,
  headingLine1 = "",
  headingLine2 = "",
}) {
  // Eğer photoUrl varsa foto, yoksa videoUrl varsa video, ikisi de yoksa medya içerik gösterilmez.
  const mediaContent = photoUrl ? (
    <Photo src={photoUrl} alt="Fotoğraf" />
  ) : videoUrl ? (
    <StyledResponsiveVideoEmbed url={videoUrl} background="transparent" />
  ) : null;

  return (
    <Container>
      <OpacityOverlay />
      <HeroContainer>
        <TwoColumn>
          <LeftColumn>
            {topNotification && <Notification>{topNotification}</Notification>}
            <Heading>
              {headingLine1 && <span>{headingLine1}</span>}
              {headingLine1 && headingLine2 && <br />}
              {headingLine2 && <SlantedBackground>{headingLine2}</SlantedBackground>}
            </Heading>
            {bottomNotification && <Notification>{bottomNotification}</Notification>}
            <ButtonsRow>
              {primaryButtonUrl && (
                <PrimaryAction as="a" href={primaryButtonUrl}>
                  {primaryButtonText}
                </PrimaryAction>
              )}
              {secondaryButtonUrl && (
                <SecondaryAction as="a" href={secondaryButtonUrl}>
                  {secondaryButtonText}
                </SecondaryAction>
              )}
            </ButtonsRow>
          </LeftColumn>
          <RightColumn>{mediaContent}</RightColumn>
        </TwoColumn>
      </HeroContainer>
    </Container>
  );
}
